import "./index.scss";
import React from "react";
import ReactDOM from "react-dom/client";
import Main from "./Main.tsx";
import { setContextToken } from "routes/home/my-courses/coursesUtils.ts";

// Store before My Courses API calls need to access it
(function () {
  setContextToken();
})();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Main />
  </React.StrictMode>
);
